import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { api } from "@/lib/api";
import { STATS_DEFAULTS } from "@/constants/content";

function Counter({ target, suffix = "+", duration = 1500 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const stepTime = 16;
    const steps = duration / stepTime;
    const inc = target / steps;
    const id = setInterval(() => {
      start += inc;
      if (start >= target) { setVal(target); clearInterval(id); }
      else setVal(Math.floor(start));
    }, stepTime);
    return () => clearInterval(id);
  }, [inView, target, duration]);
  return <span ref={ref}>{val.toLocaleString()}{suffix}</span>;
}

export default function TrustSection() {
  const [stats, setStats] = useState(STATS_DEFAULTS);
  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const items = [
    { label: "Patients Served", value: stats.patients_served, suffix: "+" },
    { label: "Professional Staff", value: stats.professional_staff, suffix: "+" },
    { label: "Emergency Support", value: 24, suffix: "×7" },
    { label: "Years of Care", value: stats.years_experience, suffix: "+" },
  ];

  return (
    <section className="py-14 md:py-16 bg-white" data-testid="trust-section">
      <div className="container-page">
        <div className="rounded-3xl bg-gradient-to-br from-[#0A84FF] via-[#0A84FF] to-[#10B981] p-8 md:p-12 relative overflow-hidden">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, white, transparent 40%), radial-gradient(circle at 80% 70%, white, transparent 35%)' }} />
          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {items.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="text-white"
                data-testid={`counter-${i}`}
              >
                <div className="font-display font-bold text-4xl md:text-5xl">
                  <Counter target={typeof s.value === "number" ? s.value : 24} suffix={s.suffix} />
                </div>
                <div className="text-xs md:text-sm uppercase tracking-[0.16em] font-semibold text-white/85 mt-2">
                  {s.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
